module.exports = __webpack_public_path__ + "img/img2.54eafda7.svg";